export default "/images/PIXL8---Final-sml.png?319f1e997969dde9ef0d15c99756ba5e";